import { BaseEntity } from "../common/baseEntity";
import { AmazonStoreCredentials } from "./AmazonStoreCredentials";

export class Seller extends BaseEntity<string>{
    public Email: string;
    public UserId: number;
    public CompanyName: string;
    public BillingAddress: string;
    public City: string;
    public State: string;
    public PostalCode: string;
    public BillingCountry: string;
    public ContactName: string;
    public Phone: string;
    public JobTitle: string;
    public RegistrStatus: SellerStatus;
    public BnNumberStatus: SellerStatus;
    public PoaNumber: SellerStatus;
    public ProductmanageStatus: SellerStatus;
    public Stores: Array<AmazonStoreCredentials>;

    public constructor(obj?: Partial<Seller>) {
        super();

        if (obj != null)
            Object.assign(this, obj);
    }
}

export enum SellerStatus{
    NotStarted = 0,
    InProgress = 1,
    Done = 2,
}


// WEBPACK FOOTER //
// ./app/objects/amazon/seller.ts